<template>
  <v-responsive
    :aspect-ratio="1 / 1.41421356"
    :style="{
      'background-image': 'url(' + imgSrc + ')',
      'background-size': 'cover',
      'background-position': 'center'
    }"
    v-bind="{
      width: isImgFixed && $vuetify.breakpoint.mdAndUp ? '200px' : 'auto'
    }"
  >
    <v-hover v-if="hoverEvent">
      <v-responsive slot-scope="{ hover }" height="100%">
        <vc-share-a
          :href="contentUrl"
          v-bind="{ target: targetBlank ? '_blank' : '_self' }"
        >
          <div
            class="d-flex"
            :style="{
              'background-color': hover
                ? 'rgba(255,255,255,0.5)'
                : 'rgba(255,255,255,0)',
              height: '100%'
            }"
          >
            <template v-if="displayIcon">
              <v-responsive
                height="36%"
                width="60%"
                max-width="60%"
                class="ma-auto"
                :aspect-ratio="2 / 1.7"
              >
                <div class="d-flex" :style="{ height: '100%' }">
                  <v-responsive
                    class="text-xs-center"
                    max-width="100%"
                    :style="{
                      display: 'flex',
                      'align-items': 'center'
                    }"
                  >
                    <transition name="fade">
                      <v-img
                        v-if="fadeOutFlag"
                        class="d-inline-block"
                        :src="playIcon"
                        width="55px"
                      ></v-img>
                    </transition>
                  </v-responsive>
                </div>
              </v-responsive>
            </template>
          </div>
        </vc-share-a>
      </v-responsive>
    </v-hover>
  </v-responsive>
</template>

<script>
export default {
  name: "vc-share-thumbnail-image",
  props: {
    imgSrc: {
      type: String,
      default: ""
    },
    contentUrl: {
      type: String,
      default: ""
    },
    hoverEvent: {
      type: Boolean,
      default: false
    },
    displayIcon: {
      type: Boolean,
      default: true
    },
    targetBlank: {
      type: Boolean,
      default: false
    },
    isImgFixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      playIcon: require("./assets/play_button.png"),
      fadeOutFlag: true
    };
  },
  mounted: function() {
    setTimeout(this.changeFadeOutFlag, 5000);
  },
  methods: {
    changeFadeOutFlag: function() {
      this.fadeOutFlag = false;
    }
  }
};
</script>

<style>
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-leave-to {
  opacity: 0;
}
</style>
